(function() {
  'use strict';

  function initSpotlight() {
    if (typeof Spotlight === 'undefined') {
      setTimeout(initSpotlight, 100);
      return;
    }

    Spotlight.init();

    const spotlightLinks = document.querySelectorAll('.spotlight');
    if (spotlightLinks.length === 0) {
      console.warn('No spotlight links found');
    }

    document.body.addEventListener('click', function(e) {
      if (
        e.target.className === 'spl-scene' ||
        e.target.className === 'spl-pane'
      ) {
        if (e.target.localName !== 'img') {
          Spotlight.close();
        }
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const spotlight = document.getElementById('spotlight');
        if (spotlight && spotlight.classList.contains('show')) {
          Spotlight.close();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpotlight);
  } else {
    initSpotlight();
  }

  document.addEventListener('product:variant-change', function() {
    setTimeout(initSpotlight, 200);
  });
})();